import { Box, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Controller, useFormContext } from 'react-hook-form';

import type { EctoparasitosFormValues } from '../schemas';

export function EctoparasitosDatosForm(): JSX.Element {
  const { control } = useFormContext<EctoparasitosFormValues>();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
        gap: 2,
      }}
    >
      <Controller
        control={control}
        name="fecha_analisis"
        render={({ field, fieldState }) => (
          <DatePicker
            label="Fecha de análisis *"
            value={field.value}
            onChange={(date) => field.onChange(date)}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                required: true,
                error: !!fieldState.error,
                helperText: fieldState.error?.message,
                onBlur: field.onBlur,
              },
            }}
          />
        )}
      />

      <Controller
        control={control}
        name="identificacion_muestras"
        render={({ field }) => (
          <TextField
            label="Identificación de muestras"
            size="small"
            fullWidth
            placeholder="Lote NOVILLOS - 320 cab."
            value={field.value ?? ''}
            onChange={(e) => field.onChange(e.target.value !== '' ? e.target.value : null)}
            onBlur={field.onBlur}
          />
        )}
      />
    </Box>
  );
}
